import { useAuthStore } from '../store/authStore';
import { authAPI } from '../api/auth';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

export const useAuth = () => {
  const { user, token, isAuthenticated, setUser, logout, setLoading } = useAuthStore();

  const login = async (email: string, password: string) => {
    try {
      setLoading(true);
      const res = await authAPI.login({ email, password });
      if (res.success && res.data) {
        setUser(res.data.user, res.data.token);
        toast.success('Welcome back');
        return res.data;
      }
    } catch (error: any) {
      const message = error.response?.data?.message || 'Login failed';
      toast.error(message);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const register = async (data: {
    email: string;
    password: string;
    first_name: string;
    last_name: string;
    phone?: string;
  }) => {
    try {
      setLoading(true);
      const res = await authAPI.register(data);
      if (res.success && res.data) {
        setUser(res.data.user, res.data.token);
        toast.success('Account created successfully');
        return res.data;
      }
    } catch (error: any) {
      const message = error.response?.data?.message || 'Registration failed';
      toast.error(message);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const logoutUser = () => {
    logout();
    toast.success('Logged out');
  };

  const isAdmin = user?.role === 'admin' || user?.role === 'super_admin';
  const isSuperAdmin = user?.role === 'super_admin';

  return {
    user,
    token,
    isAuthenticated,
    isAdmin,
    isSuperAdmin,
    login,
    register,
    logout: logoutUser,
  };
};